import type { FulfillmentOwner } from "./fulfillment-hours";

export type ShippingChoice = "yes" | "no" | undefined;

type CheckoutFulfillment = {
  wantsDelivery: Exclude<ShippingChoice, undefined>;
  wantsRecovery: Exclude<ShippingChoice, undefined>;
  owner: FulfillmentOwner;
  requiresShippingAddress: boolean;
};

export const resolveCheckoutFulfillment = (wantsDelivery: ShippingChoice): CheckoutFulfillment => {
  const normalizedChoice = wantsDelivery === "no" ? "no" : "yes";

  return {
    wantsDelivery: normalizedChoice,
    wantsRecovery: normalizedChoice,
    owner: normalizedChoice === "yes" ? "festi" : "customer",
    requiresShippingAddress: normalizedChoice === "yes",
  };
};
